// External Imports
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

// PPUI Imports
import { Container } from '@paypalcorp/pp-react-grid';

// Internal Imports
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import { validate } from '../../lib/clientValidatorV3';
import AmountSetup from './AmountSetup';
import StepHeader from './components/StepHeader';
import { isDonateButton, isHostedFlow } from '../../utils/buttonFactoryUtils';
import MailingAddressSwitch from './components/MailingAddressSwitch';
import Note from './components/Note';
import AdvancedUrls from './components/AdvancedUrls';
import AdvancedVariables from './components/AdvancedVariables';
import RecurringSwitch from '../switchPanels/RecurringSwitch';
import CoverFeesSwitch from '../switchPanels/CoverFeesSwitch';
import ProgramsV3 from '../programs/ProgramsV3';
import WizardNavButtons from '../navigationButtons/WizardNavButtons';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';
import { trackEventWithData } from '../../utilsV3/analytics';

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3: { formattedButton = {} } = {} } =
    state;

  return {
    application,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: formattedButton,
  };
};

const WizardStep3 = ({
  handleBack,
  handleSubmit,
  application,
  formValues,
  change,
}) => {
  const trackPageLoadImpression = () => {
    if (isDonateButton()) {
      trackEventWithData(FPTI_SPEC.SET_AMOUNT_PAGE_IM, { step: 3 });
    } else {
      trackEventWithData(FPTI_SPEC.ADVANCED_SETTINGS_PAGE_IM, { step: 3 });
    }
  };

  useEffect(() => {
    trackPageLoadImpression();
  }, []);

  return (
    <>
      <Container className="wizard-step-container">
        <StepHeader />

        <form onSubmit={handleSubmit} className="wizard-form">
          {isDonateButton() ? (
            <>
              <AmountSetup
                application={application}
                formValues={formValues}
                change={change}
              />
              <RecurringSwitch />
              {isHostedFlow() ? (
                <>
                  <CoverFeesSwitch
                    showBadge={application.showNewFeatureBadge ?? false}
                  />
                  <ProgramsV3 />
                </>
              ) : null}
            </>
          ) : (
            <>
              <MailingAddressSwitch
                isChecked={formValues.noShipping === 'no'}
              />
              <Note
                isChecked={formValues.noNote === 'no'}
                showBadge={application.showNewFeatureBadge ?? false}
              />
              <AdvancedUrls noCancelReturn={formValues.noCancelReturn} />
              <AdvancedVariables
                extraVariablesView={formValues.extraVariablesView}
                noAdvancedVariables={formValues.noAdvancedVariables}
              />
            </>
          )}
        </form>
      </Container>
      <WizardNavButtons handleBack={handleBack} handleSubmit={handleSubmit} />
    </>
  );
};

WizardStep3.propTypes = {
  buttonFactoryV3: PropTypes.object,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
  application: PropTypes.object,
  formValues: PropTypes.object,
  change: PropTypes.func,
  onSubmit: PropTypes.func,
};

let WizardStep3Form = reduxForm({
  form: BTN_FACTORY_V3_FORM,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardStep3);

WizardStep3Form = connect(mapStateToProps)(WizardStep3Form);

export default WizardStep3Form;
